module.exports = {"id":"197777","name":"Jacopo Sala","rating":"73","photo":"./data/images/photos/0/197777.png","club":{"name":"Sampdoria","logo":"./data/images/clubs/Sampdoria.png"},"positions":["DD","MD","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JacopoSala0.json
// module id = 1870
// module chunks = 0